import { Slider } from 'antd';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

const DynamicFieldInputSlider = ({ value, onChange, ...props }) => {
  return <Slider value={value} onChange={onChange} {...props} />;
};

DynamicFieldInputSlider.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default memo(DynamicFieldInputSlider);
